import React from 'react';
import Modal from 'react-modal';
import Row from '../tag/Row';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import { OTLink } from '../tag/OTLink';
import modal from '../../definitions/Modal';
import { FormattedMessage, injectIntl } from 'react-intl';

const notificationModal = modal({ content: { width: '500px' } });

const NavigationModal = (props) => {
  let { data, hideModal, isExternal, intl, ...rest } = props;
  return (
    <Modal
      {...rest}
      shouldReturnFocusAfterClose
      shouldFocusAfterRender
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={hideModal}
      contentLabel={intl.formatMessage({ id: 'modal' })}
      style={notificationModal}
    >
      <Row>
        <div className="ot-nav__modal__wrapper">
          {data.text.map((t, index) => {
            return (
              <FormattedMessage key={`modal-msg-${index}`} id={t}>
                {(txt) => (
                  <p className="ot-nav__modal__wrapper__paragraph">{txt}</p>
                )}
              </FormattedMessage>
            );
          })}
        </div>
      </Row>
      <Row>
        <OTButtonGroup type="big" fullWidth={true}>
          <OTButton
            className="ot-nav__modal__button"
            key="cancel"
            onClick={hideModal}
            aria-label={intl.formatMessage({ id: 'cancel' })}
          >
            <FormattedMessage id="cancel" />
          </OTButton>
          <OTLink
            key="submit"
            isExternal={isExternal}
            link={data.link}
            target={data.target}
            onClick={hideModal}
            aria-label={intl.formatMessage({ id: 'continue' })}
            className={'ot-button ot-button--big'}
            style={{ padding: '10px 0', textAlign: 'center' }}
          >
            <FormattedMessage id="continue" />
          </OTLink>
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default injectIntl(NavigationModal);
